export default "__VITE_ASSET__B9GEZw7P__"